<!-- Abas à esquerda; Adicionar, Busca avançada e a dica da ordenação à direita, na mesma linha. -->
<div class="vdi-cabecalho">
  <div class="abas-itens">
    @for (a of abas; track a.key) {
      <button type="button" class="aba" [class.aba-ativa]="abaAtiva === a.key" (click)="aba = a.key">
        {{ a.label }}
      </button>
    }
  </div>

  <div class="vdi-acoes">
    @if (!isSomenteLeitura) {
      <button mat-button type="button" class="btn-section" (click)="adicionar($event)">
        <mat-icon class="material-symbols-outlined">add_circle</mat-icon>
        Adicionar item
      </button>

      <button mat-button type="button" class="btn-section" (click)="abrirBuscaAvancada()">
        <mat-icon class="material-symbols-outlined">search</mat-icon>
        Busca avançada
      </button>
    }

    <mat-icon class="material-symbols-outlined vdi-info"
      matTooltip="Organize seus itens como preferir. Arraste a alça para mudar a ordem dos itens. Itens de um mesmo kit permanecem juntos, mas você pode mover o kit completo de uma só vez. A sequência mostrada aqui será a mesma usada na impressão.">info</mat-icon>
  </div>
</div>

<app-vd-itens-lista
  [itens]="itens"
  [aba]="abaAtiva"
  [calcularImpostos]="calcularImpostos"
  [isSomenteLeitura]="isSomenteLeitura"
  [tetoDesconto]="tetoDesconto"
  [idListaCabecalho]="idListaCabecalho"
  [priorizarMenorPreco]="priorizarMenorPreco"
  [listasPorProduto]="listasPorProduto"
  [tipoValidacaoEstoqueNegativo]="tipoValidacaoEstoqueNegativo"
  [idVenda]="idVenda"
  [linhaEmEdicao]="linhaEmEdicao"
  [linhaNova]="linhaNova"
  [mascaraPreco]="mascaraPreco"
  [mascaraQuantidade]="mascaraQuantidade"
  [mascaraInteira]="mascaraInteira"
  (editar)="editar($event)"
  (detalhesEstoque)="detalhesEstoque($event)"
  (excluir)="remover($event)"
  (editarNaLinha)="editarNaLinha($event)"
  (sairDaEdicao)="sairDaEdicao()"
  (salvarLinha)="salvarLinha()"
  (descartarLinha)="descartarLinha()"
  (produtoEscolhido)="registrarListasDoProduto($event)"
  (kitEscolhido)="aoEscolherKit($event)"
  (multiploEscolhido)="aoMultiploEscolhido($event)"
  (editarMultiplo)="editarMultiplo($event)"
  (excluirKit)="excluirKit($event)"
  (aviso)="avisar($event)"
  (reordenou)="renumerar()">
</app-vd-itens-lista>
